import { inject, provide } from 'vue';
export const ResizeContextKey = Symbol('ResizeContextProps');
export const useProvideResize = (props) => {
    provide(ResizeContextKey, props);
};
export const useInjectResize = () => {
    return inject(ResizeContextKey, { onColumnResize: () => { } });
};
export const ResizeColumnMoveRefKey = Symbol('ResizeColumnMoveRef');
export const FullTableRefKey = Symbol('FullTableRef');
export const HasDataKey = Symbol('hasData');
export const ResizeColumnStartRefKey = Symbol('ResizeColumnStartRef');
export const InitTableScrollKey = Symbol('InitTableScrollProps');
export const useProvideInitScroll = (props) => {
    provide(InitTableScrollKey, props);
};
export const useInjectInitScroll = () => {
    return inject(InitTableScrollKey, { onInitTableScroll: () => { } });
};
export const ResizeColumnStatusKey = Symbol('ResizeColumnStatusKey');
